import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class OperationShiftEmployeeConstants {
    public static ASSIGNED_TO_ME_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.OPERATION_ASSIGNED_TO_ME_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: false
    };

    public static COMPLETED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.OPERATION_COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: false
    };

   

    public static COMPLETED_HISTORY_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_HISTORY_REQUESTS,
        tableColumn: TablePropertiesConstants.COMPLETED_HISTORY_REQUESTS_COLUMNS,
        tableWithSelection: false
    };
}
